module.exports = __webpack_public_path__ + "static/13.2_the_rise_of_rome-0bf8ca3761510fe9b28a5a601fcf38ba.pdf";